"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _connectField = _interopRequireDefault(require("uniforms/connectField"));

var _filterDOMProps = _interopRequireDefault(require("uniforms/filterDOMProps"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noneIfNaN = function noneIfNaN(x) {
  return isNaN(x) ? undefined : x;
};

var parse = function parse(decimal, x) {
  return noneIfNaN((decimal ? parseFloat : parseInt)(x));
};

var Num_ = function Num_(_ref) {
  var decimal = _ref.decimal,
      disabled = _ref.disabled,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      helperText = _ref.helperText,
      inputProps = _ref.inputProps,
      inputRef = _ref.inputRef,
      label = _ref.label,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      showInlineError = _ref.showInlineError,
      value = _ref.value,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["decimal", "disabled", "error", "errorMessage", "helperText", "inputProps", "inputRef", "label", "max", "min", "name", "onChange", "placeholder", "showInlineError", "value"]);
  return _react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    disabled: !!disabled,
    error: !!error,
    helperText: error && showInlineError && errorMessage || helperText,
    inputProps: _objectSpread({
      min: min,
      max: max,
      step: decimal ? 0.01 : 1
    }, inputProps),
    label: label,
    name: name,
    onChange: onChange,
    placeholder: placeholder,
    ref: inputRef,
    type: "number",
    value: value
  }, (0, _filterDOMProps["default"])(props)));
};

Num_.defaultProps = {
  fullWidth: true,
  margin: 'dense'
};
var Num; // istanbul ignore next

if (parseInt(_react["default"].version, 10) < 16) {
  var _temp;

  Num = (_temp =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(Num, _Component);

    function Num() {
      var _getPrototypeOf2;

      var _this;

      (0, _classCallCheck2["default"])(this, Num);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Num)).call.apply(_getPrototypeOf2, [this].concat(args)));
      _this.state = {
        value: '' + _this.props.value
      };

      _this.onChange = function (event) {
        var value = event.target.value.replace(/[^\d.,-]/g, '');

        _this.setState({
          value: value
        });

        _this.props.onChange(parse(_this.props.decimal, value));
      };

      return _this;
    }

    (0, _createClass2["default"])(Num, [{
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(_ref2) {
        var decimal = _ref2.decimal,
            value = _ref2.value;

        if (parse(decimal, value) !== parse(decimal, this.state.value.replace(/[.,]+$/, ''))) {
          this.setState({
            value: value === undefined || value === '' ? '' : '' + value
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return Num_(_objectSpread({}, this.props, {
          onChange: this.onChange,
          value: this.state.value
        }));
      }
    }]);
    return Num;
  }(_react.Component), _temp);
} else {
  Num = function Num(props) {
    return Num_(_objectSpread({}, props, {
      onChange: function onChange(event) {
        props.onChange(parse(props.decimal, event.target.value));
      }
    }));
  };
}

var _default = (0, _connectField["default"])(Num);

exports["default"] = _default;